import React from 'react';
import { useState } from 'react';
import './DeploymentManagerStyle.css'

function DeploymentManager(props) {

    const datacenters = props.datacenters;
    const [values, setValues] = useState({
        fileName: '', datacenter: '', endpointToCall: '', secretKey: ''
    });

    const set = fileName => {
        return ({ target: { value } }) => {
        setValues(oldValues => ({...oldValues, [fileName]: value }));
        }
    };

    // empty array for logs
    const postLogs = [];

    // make post logs array reactive
    const [postErrorLogs, setPostLogs] = useState(postLogs);


    const onSubmit = async (event) => {

        // clear old logs after new submit
        setPostLogs([]);
        
        event.preventDefault();
        try {
          console.log("running POST calls async...")
          await runPostCalls();
          setValues({
            fileName: '', datacenter: '', endpointToCall: ''
          });
        } catch (e) {
          alert(`POST call failed! ${e.message}`);
        }
    }

    function runPostCalls() {
        try{

          if (values.endpointToCall === "update3DApp") {

              if (!UpdatePathValidator(values.fileName)) {
                  alert('Invalid path')
                  return;
              }

          } else if (values.endpointToCall === "preInstallBuild") {

              if (!PreInstallPathValidator(values.fileName)) {
                  alert('Invalid path')
                  return;
              }
          }

            // set of vmAgents that will be updated
            let vmAgentUpdateSet = new Set();
            // from each unreal application.. ensure we collect all vmagents to update
            props.DeploymentManager.forEach(currMachine => {
              if(values.datacenter === currMachine.datacenter){
                vmAgentUpdateSet.add(currMachine.hostName + "/" + values.endpointToCall)
              }
            });

            // calculate POST body
            var jsonBody = {};

            if (values.endpointToCall === "update3DApp") {

                jsonBody.new3DAppName = values.fileName;
                jsonBody.secretKey = values.secretKey;

            } else {

                jsonBody.fileName = values.fileName;

            }

            alert('POST call Running...');

            // make update call to each vmAgent
            vmAgentUpdateSet.forEach(vmAgentUpdateEndpoint => {
              // complete updates
              httpPost(vmAgentUpdateEndpoint, jsonBody)
            });
    
        }catch(e){
          console.log(e)
        }
    }

    function UpdatePathValidator(path) {

        // takes filename from path
        let fullFileName = path.split("/").pop();
        let fileNameStart = fullFileName?.split("-").shift();

        // filename does not start with InvictusVehicleConfigurator return false
        return fileNameStart != "InvictusVehicleConfigurator" ? false : true;
    }

    function PreInstallPathValidator(path) {

        // takes filename from path
        let fullFileName = path.split("/").pop();
        let fileNameStart = fullFileName?.split("-").shift();

        // filename does not start with InvictusVehicleConfigurator return false
        if (fileNameStart != "InvictusVehicleConfigurator"){
            return false;
          }

          // path same for prod, dev, qa and test
          return path.includes("3dAppBuilds/") && path.endsWith(".zip") ? true : false;
    }

    function httpPost(theUrl, theBody)  {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
    
        var raw = JSON.stringify(theBody);
    
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow'
        };
    
        fetch(theUrl, requestOptions)
          .then(response => response.text())
          .then(result => {
            setPostLogs(oldArray => [...oldArray, theUrl + "\n" + String(result)].sort((a, b) =>
            a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })));
          })
          .catch(error => setPostLogs(oldArray => [...oldArray, theUrl + "\n" + String(error)].sort((a, b) =>
          a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))));
      }

  return (
    <form onSubmit={onSubmit}>
      <h2>Deployment Manager Endpoints</h2>
      <div>
        <label>Filename: </label>
        <input type="text" required value={values.fileName} onChange={set('fileName')}/>
      </div>

      <div>
      <label>Endpoint: </label>
        <select name="endpointToCall" onChange={set('endpointToCall')}>
            <option value="" disabled selected hidden>Select</option>
            <option value="preInstallBuild">preInstallBuild</option>
            <option value="validate3dAppInstalled">validate3dAppInstalled</option>
            <option value="update3DApp">update3DApp</option>
        </select>
      </div>

      <div>
        {values.endpointToCall === "update3DApp" ? 
        <React.Fragment>
          <label>Secret Key: </label>
          <input type="password" required value={values.secretKey} onChange={set('secretKey')}/>
        </React.Fragment>
        : 
        <p></p> }
      </div>

      <div>
      <label>Datacenter*: </label>
        <select required value={values.datacenter} onChange={set('datacenter')}>
          <option value="">Select</option>
          {datacenters.map(c => <option key={c}>{c}</option>)}
        </select>
      </div>

      <div>
        <button type="submit">Submit</button>
      </div>

      <input id="collapsible-3d" className="toggle-3d" type="checkbox"></input>
      <label htmlFor="collapsible-3d" className="lbl-toggle-3d">Post Logs</label>
      <div className="collapsible-content-3d">
        <div className="content-inner-3d">
          <ul id="postData-3d">
            {postErrorLogs.map(log => <li id="postLog-3d" key={log}>{log}</li>)}
          </ul>
        </div>
      </div>
    </form>
  );
}

export default DeploymentManager;
